import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { excuseApi } from '../../commons/http';

const BONUS_REASONS = [
  { value: 'REFERRAL', label: 'Giới thiệu khách hàng' },
  { value: 'PROMOTION', label: 'Khuyến mãi' },
  { value: 'COMPENSATION', label: 'Bồi thường/Đền bù' },
  { value: 'OTHER', label: 'Khác' },
];

const AddBonusDialog = ({ open, onClose, userPackageId, onSuccess }) => {
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    // Validation
    if (!amount || parseFloat(amount) <= 0) {
      setError('Vui lòng nhập số lượng hợp lệ (> 0)');
      return;
    }
    if (!reason) {
      setError('Vui lòng chọn lý do');
      return;
    }
    if (reason === 'OTHER' && !note.trim()) {
      setError('Vui lòng nhập ghi chú khi chọn lý do "Khác"');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await excuseApi({
        path: `/user-packages/${userPackageId}/bonuses`,
        method: 'POST',
        body: {
          amount: parseFloat(amount),
          reason,
          note: note.trim() || null,
        }
      });

      if (response.status === 201) {
        onSuccess(response.data.data);
        handleClose();
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Có lỗi xảy ra. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAmount('');
    setReason('');
    setNote('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Thêm khối lượng tặng thêm</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2, mt: 1 }}>
            {error}
          </Alert>
        )}

        <TextField
          autoFocus
          margin="dense"
          label="Số lượng (kg)"
          type="number"
          fullWidth
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          inputProps={{ min: 0.01, step: 0.01 }}
          required
          sx={{ mt: 1 }}
        />

        <FormControl fullWidth margin="dense" required>
          <InputLabel>Lý do</InputLabel>
          <Select
            value={reason}
            label="Lý do"
            onChange={(e) => setReason(e.target.value)}
          >
            {BONUS_REASONS.map((r) => (
              <MenuItem key={r.value} value={r.value}>
                {r.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          margin="dense"
          label="Ghi chú"
          multiline
          rows={3}
          fullWidth
          value={note}
          onChange={(e) => setNote(e.target.value)}
          required={reason === 'OTHER'}
          helperText={reason === 'OTHER' ? 'Bắt buộc khi chọn lý do "Khác"' : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Hủy
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Đang xử lý...' : 'Thêm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddBonusDialog;
